import DetailForm from "./components/DetailForm";
import SectionHeader from "../../components/SectionHeader";

const ConsignmentDetails = props => {
  const { consignment, formik } = props;

  return (
    <div className="w-full">
      <SectionHeader title={`Consignment #${consignment?.id}`} />
      <div className="flex flex-col gap-8 px-4 pb-[50px] sm:px-6 lg:flex-row lg:gap-0 lg:space-x-20 lg:px-0 lg:pl-[50px]">
        <div className="w-full max-w-[1900px]">
          <div className="flex flex-col gap-8 lg:flex-row lg:gap-0 lg:space-x-10">
            <DetailForm
              formik={formik}
              consignment={consignment}
              submitOnBlur={true}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConsignmentDetails;
